import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hook";
import {
  POSTS_GET_ALL,
  POSTS_ADD,
  POSTS_DELETE,
  POSTS_UPDATE,
} from "src/store/post/action";
import {
  createPost,
  deletePostApi,
  getAllPosts,
  updatePost,
} from "src/services/postServices";

function usePost() {
  const { posts } = useAppSelector((state) => state.post);
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  // Lấy tất cả bài viết
  const fetchPosts = async () => {
    try {
      setLoading(true);
      const response = await getAllPosts();
      dispatch(POSTS_GET_ALL({ posts: response.data }));
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoading(false);
    }
  };

  // Thêm bài viết
  const addPost = async (postData: any) => {
    try {
      const response = await createPost(postData);
      dispatch(POSTS_ADD({ post: response.data }));
      await fetchPosts(); // đồng bộ lại dữ liệu
    } catch (error) {
      console.error("Error adding post:", error);
    }
  };

  // Cập nhật bài viết
  const editPost = async (postData: any) => {
    try {
      const response = await updatePost(postData);
      dispatch(POSTS_UPDATE({ post: response.data }));
      await fetchPosts(); // đồng bộ lại dữ liệu
    } catch (error) {
      console.error("Error updating post:", error);
    }
  };

  // Xóa bài viết
  const deletePost = async (postId: string) => {
    try {
      await deletePostApi(postId);
      dispatch(POSTS_DELETE({ postId }));
      await fetchPosts(); // đồng bộ lại dữ liệu
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  return {
    posts,
    isLoading,
    addPost,
    editPost,
    deletePost,
    fetchPosts
  };
}

export default usePost;
